import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { invert } from 'lodash';
import { eventByType } from '../../../../../../api/eventsApi';
import tagular from '../../../../../../util/tagular';
import { elementViewed } from '../../../../../../actions/elementsViewedActions';

const DefaultCardContent = props => {
    const {
        result,
        assessment,
        inlineParentMetadata,
        elementsViewed,
        distpatchElementViewed,
        inViewport,
        forwardedRef
    } = props;

    let image;
    let description;
    let options;

    const handleReadMoreClick = e => {
        eventByType('read-more', assessment.id, { inlineParentMetadata });

        tagular.sendElementClickedEvent(e, {
            assessmentName: assessment.internalName,
            name: result.title,
            outboundUrl: result.url,
            action: 'INTERNALLINK'
        });
    };

    const handleElementViewed = () => {
        distpatchElementViewed(result.title);
        tagular.sendElementViewedEvent({
            assessmentName: assessment.internalName,
            name: result.title,
            elementType: 'BUTTON',
            text: 'READ MORE'
        });
    };

    if (result.imageUrl && result.imageUrl !== '') {
        image = (
            <div className="img-container">
                <img className="result-img" src={result.imageUrl} alt="" />
            </div>
        );
    }

    if (result.briefDescription && result.briefDescription !== '') {
        description = (
            <div
                className="description"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: result.briefDescription }}
            />
        );
    }

    if (result.url && result.url !== '') {
        options = (
            <div className="options">
                <a
                    href={result.url}
                    className="review button"
                    target="_blank"
                    onClick={e => handleReadMoreClick(e)}
                >
                    {result.cta ? result.cta : 'READ MORE'}
                </a>
            </div>
        );
    }

    useEffect(() => {
        if (inViewport && !elementsViewed.includes(result.title)) {
            handleElementViewed();
        }
    }, [inViewport]);

    return (
        <div className="result-card" ref={forwardedRef}>
            {image}

            <div className="result-card-content">
                <h1 className="title">{result.title}</h1>

                {description}
                {options}
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        inlineParentMetadata: state.inline.parentMetadata,
        elementsViewed: state.session.elementsViewed
    };
};

const mapDispatchToProps = dispatch => {
    return {
        distpatchElementViewed: element => dispatch(elementViewed(element))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultCardContent);
